var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopyWhite = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#444a58;}.a{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3,2h8a2,2,0,0,1,2,2V14a2,2,0,0,1-2,2H3a2,2,0,0,1-2-2V4A2,2,0,0,1,3,2ZM3,3A1,1,0,0,0,2,4V14a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V4a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5,0h8a2,2,0,0,1,2,2V12a2,2,0,0,1-2,2V13a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H5A1,1,0,0,0,4,2H3A2,2,0,0,1,5,0Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopyWhite);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE0IDE2Ij48ZGVmcz48c3R5bGU+LmEsLmJ7ZmlsbDojNDQ0YTU4O30uYXtmaWxsLXJ1bGU6ZXZlbm9kZDt9PC9zdHlsZT48L2RlZnM+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEpIj48cGF0aCBjbGFzcz0iYSIgZD0iTTMsMmg4YTIsMiwwLDAsMSwyLDJWMTRhMiwyLDAsMCwxLTIsMkgzYTIsMiwwLDAsMS0yLTJWNEEyLDIsMCwwLDEsMywyWk0zLDNBMSwxLDAsMCwwLDIsNFYxNGExLDEsMCwwLDAsMSwxaDhhMSwxLDAsMCwwLDEtMVY0YTEsMSwwLDAsMC0xLTFaIi8+PHBhdGggY2xhc3M9ImIiIGQ9Ik01LDBoOGEyLDIsMCwwLDEsMiwyVjEyYTIsMiwwLDAsMS0yLDJWMTNhMSwxLDAsMCwwLDEtMVYyYTEsMSwwLDAsMC0xLTFINUExLDEsMCwwLDAsNCwySDNBMiwyLDAsMCwxLDUsMFoiLz48L2c+PC9zdmc+";